import { TicketWindowEnd, TicketWindowStart } from '@givebacks/api/store';
import { DateTime } from 'luxon';
import { centsToDollar } from 'ui';

import { TicketRowActions } from './columnComponents';
import { TicketsTableInstance } from './tableInstance';

const salesDateFormatter = (
  ticketWindowData: TicketWindowStart | TicketWindowEnd,
  date?: string
) => {
  const dateStringMap = {
    on_publish_date: 'Publish date',
    on_event_date: 'Event date',
    x_time_before_event_date:
      ticketWindowData?.units === 'hours'
        ? '1 hour after event starts'
        : `${ticketWindowData?.delta} day${ticketWindowData?.delta === 1 ? '' : 's'} before event`,
    one_hour_after_event_starts: '1 hour after event starts',
    after_event: '1 hour after last event starts',
    custom_date: date ? DateTime.fromISO(date).toFormat('MM/dd/yy h:mm a') : '',
  };

  return dateStringMap[ticketWindowData?.type ?? ''];
};

const ticketTypeTableColumns = [
  TicketsTableInstance.columnHelper.accessor('name', { header: 'Name', enableSorting: false }),
  TicketsTableInstance.columnHelper.accessor('ticket_window_data.start.type', {
    header: 'Ticket Sales Start',
    cell: (props) =>
      salesDateFormatter(
        props.row.original.ticket_window_data?.start,
        props.row.original.starting_at
      ),
    enableSorting: false,
  }),
  TicketsTableInstance.columnHelper.accessor('ticket_window_data.end.type', {
    header: 'Ticket Sales End',
    cell: (props) =>
      salesDateFormatter(props.row.original.ticket_window_data?.end, props.row.original.expires_at),
    enableSorting: false,
    size: 250,
  }),
  TicketsTableInstance.columnHelper.accessor('content.available_quantity', {
    header: 'Tickets Available',
    cell: (props) => (props.row.original.unlimited ? 'Unlimited' : props.getValue()),
    enableSorting: false,
  }),
  TicketsTableInstance.columnHelper.accessor('price', {
    header: 'Ticket Price',
    enableSorting: false,
    cell: (props) => centsToDollar(props.row.original.price),
  }),
  TicketsTableInstance.columnHelper.display({
    id: 'actions',
    cell: (props) => <TicketRowActions {...props} />,
    size: 40,
  }),
];

export { ticketTypeTableColumns };
